import { Battery, Wifi, Zap, HardDrive } from 'lucide-react';
import { Card } from './ui/card';
import { useDeviceStats } from '../hooks/useDeviceStats';

export function StatsDisplay() {
  const stats = useDeviceStats();

  const statCards = [
    {
      label: 'Battery',
      value: stats.battery,
      unit: '%',
      icon: Battery,
      color: 'text-primary',
    },
    {
      label: 'Ping',
      value: stats.ping,
      unit: 'ms',
      icon: Wifi,
      color: 'text-accent',
    },
    {
      label: 'FPS',
      value: Math.round(stats.fps),
      unit: '',
      icon: Zap,
      color: 'text-primary',
    },
    {
      label: 'Storage',
      value: stats.storage,
      unit: '%',
      icon: HardDrive,
      color: 'text-muted-foreground',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      {statCards.map(stat => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} className="p-4 backdrop-blur-sm border-primary/30">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-medium text-muted-foreground">{stat.label}</span>
              <div className="p-2 rounded-lg bg-secondary">
                <Icon className={`${stat.color}`} size={16} />
              </div>
            </div>
            <div className="text-2xl font-bold text-foreground">
              {stat.value}
              <span className="text-sm ml-1 text-muted-foreground">{stat.unit}</span>
            </div>
            <div className="mt-3 h-1 bg-secondary rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-500"
                style={{ width: `${Math.min(100, stat.value)}%` }}
              />
            </div>
          </Card>
        );
      })}
    </div>
  );
}